module.exports = __webpack_public_path__ + "3fe4d0100ca0574adaf0d3ead72b78d1.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_l_40.mp3
// module id = 459
// module chunks = 0